import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import useLanguageOptions from '../hooks/useLanguageOptions';
import usePermissions from '../hooks/usePermissions';
import AdminSessions from './admin/AdminSessions';
import RecordingModal from '../components/dashboard/RecordingModal';

/** Court App sessions list — same table/filters as Court Admin, linked to court transcripts. */
const Sessions = () => {
  const { user } = useAuth();
  const { languages } = useLanguageOptions();
  const { canRecord } = usePermissions();
  const [showRecordingModal, setShowRecordingModal] = useState(false);

  const courtDisplayName = user?.court_name || user?.courtName || 'Court not assigned';
  const initiatorDisplayName = user
    ? `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email
    : 'Unknown user';

  return (
    <>
      <AdminSessions
        transcriptBasePath="/transcriptions"
        onStartRecording={canRecord ? () => setShowRecordingModal(true) : null}
        showMediaActions={false}
      />
      <RecordingModal
        open={showRecordingModal}
        onClose={() => setShowRecordingModal(false)}
        courtDisplayName={courtDisplayName}
        initiatorDisplayName={initiatorDisplayName}
        languages={languages}
      />
    </>
  );
};

export default Sessions;
